import { useSelector } from "react-redux"

const useDAuth = () => {
  return {
    ...useSelector(state => ({
      isAuthLoading: state.dAuth.isAuthLoading,
      isAuthentication: state.dAuth.isAuthentication,
    })),
  }
}

export default useDAuth
